export default "__VITE_ASSET__9e0fe166__"